module.exports = __webpack_public_path__ + "static/media/intro-hero-people--mobile.5c4eebfb.png";